var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "main-menu" },
    [
      _c("content-creator", {
        attrs: {
          settings: _vm.getBlobContents(_vm.menuName),
          permissions: _vm.contentCreatorPermissions,
          "is-visible": _vm.isEditable,
          "menu-style": _vm.menuStyle,
          filestore: _vm.websitefilestore,
          name: _vm.menuName,
          "allowed-widgets": "menu-editor",
        },
        on: { updateBlob: (data) => _vm.saveBlob(_vm.menuName, data) },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }